module.exports = __webpack_public_path__ + "static/img/Rakennustuotteiden-laatu.28a7884.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Rakennustuotteiden-laatu.png
// module id = DHL0
// module chunks = 4